'use client';

import { useUser } from '@clerk/nextjs';
import { useRouter } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import InnerLayout from './components/common/InnerLayout/InnerLayout';
import { ScreenLoader } from './components/common/loaders/ScreenLoader';
import { isProfileComplete } from '../lib/auth/isProfileComplete';

export default function DashboardPage() {
  const { user, isLoaded } = useUser();
  const router = useRouter();

  useEffect(() => {
    if (isLoaded && !user) {
      router.push('/sign-in');
    } else if (isLoaded && !isProfileComplete(user ?? null)) {
      router.push('/user');
    }
  }, [user, isLoaded, router]);

  if (!isLoaded) {
    return (<ScreenLoader />)
  }

  if (user == undefined || user == null) {
    return (<ScreenLoader />)
  }

  return (
    <>
      <Suspense fallback={<ScreenLoader />}>
        <div className="flex grow">

          <InnerLayout>
            <div className="container-fixed">
              <div className="flex flex-wrap items-center justify-between gap-5 pb-7.5">
                <div className="flex flex-col justify-center gap-2">
                  <h1 className="text-xl font-medium leading-none text-gray-900">Dashboard</h1>
                  <div className="flex items-center gap-2 text-sm font-normal text-gray-700">Central Hub for Personal Customization</div>
                </div>
              </div>
            </div>
          </InnerLayout>
        </div>
      </Suspense>
    </>
  );
}